import { render, staticRenderFns } from "./AdminNewsLettersView.vue?vue&type=template&id=36af9f4a&scoped=true&"
import script from "./AdminNewsLettersView.vue?vue&type=script&lang=js&"
export * from "./AdminNewsLettersView.vue?vue&type=script&lang=js&"
import style0 from "./AdminNewsLettersView.vue?vue&type=style&index=0&id=36af9f4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36af9f4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
